// src/mis/data/machineList.js
import env from "react-dotenv";

export const fetchDepartmentsWithMachines = async () => {
  try {
      const response = await fetch(`${process.env.REACT_APP_PJCBACKEND_URL}/api/machinelist/by-department`);
      const data = await response.json();
      return data; // This will be an object with department names as keys and machine names as values
  } catch (error) {
      console.error("Error fetching departments with machines:", error);
      return {};
  }
};